import { render, staticRenderFns } from "./userAmt.vue?vue&type=template&id=253feab4&scoped=true&"
import script from "./userAmt.vue?vue&type=script&lang=js&"
export * from "./userAmt.vue?vue&type=script&lang=js&"
import style0 from "./userAmt.vue?vue&type=style&index=0&id=253feab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253feab4",
  null
  
)

export default component.exports